// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZBd2","top":"styles_top__1GzJZ"};